import React from 'react'
import { useState, useEffect } from 'react'
import Tabs from '../../../../Components/Tabs'
import { Link, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Tab1 from './Tab1'
import Tab2 from './Tab2'
import Tab3 from './Tab3'
import Tab4 from './Tab4'
import Table from './Table'
import GetIcon from '../../../../utils/Icon'
import Button from '../../../../Core/Button/Button'
import { useGetDeliveryNoteDocQuery } from '../../../../store/api/deliveryNoteApi'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import { useCreateSalesReturnMutation, useSaveSalesReturnMutation, useUpdateSalesReturnMutation, useSubmitDeliveryNoteMutation } from '../../../../store/api/salesReturnApi'

import Tab5 from './Tab5'
import Attachment from '../../../../utils/Attachment'

function SalesReturn({ deliveryNoteId }) {
    // function Deliverynote() {





    const nvg = useNavigate()
    const [buttonData, setButtonData] = useState(false)
    const [errorr, setError] = useState('');
    const [ptype, setptype] = useState("Error ")
    const [showError, setShowError] = useState(false);
    const [submitboll, setsubmitboll] = useState(false)

    const [tab, settab] = useState(1)
    const [showDropdown, setShowDropdown] = useState(false);
    const handleNavigate = (path) => {
        nvg(path);
        setShowDropdown(false);
    };
    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };


    const [deliveryNoteData, setDeliveryNoteData] = useState(null);
    const [salesreturnfulldata, setsalesreturnfulldata] = useState(null);

    const [deliveryNoteItems, setDeliveryNoteItems] = useState([]);
    const [submit, setsubmit] = useState(false);
    const [shipmentItems, setshipmentItems] = useState([]);

    const [activityboll, setactivityboll] = useState(false)


    const [createSalesReturn, { data, error, isLoading, isSuccesss }] =
        useCreateSalesReturnMutation();

    console.log(data);

    useEffect(() => {
        const payload = {
            method: "erpnext.stock.doctype.delivery_note.delivery_note.make_sales_return",
            source_name: deliveryNoteId

        };

        createSalesReturn(payload);
    }, [createSalesReturn]);

    useEffect(() => {
        if (data?.message) {
            const fullDoc = data.message;
            const { items, ...rest } = fullDoc;

            setDeliveryNoteItems(items || []);

            setDeliveryNoteData(rest);
            setsalesreturnfulldata(fullDoc)
        }
    }, [data]);

    const [
        saveSalesReturn,
        { isLoading: saving, isError: hasError, isSuccess: success, data: response, error: saveError }
    ] = useSaveSalesReturnMutation();

    const [salesreturn_id, setSalesreturnId] = useState("");

    const handleSave = async () => {
        console.error(' call_save_sales_return', salesreturnfulldata);
        const payload = { doc: salesreturnfulldata };
        try {
            const result = await saveSalesReturn(payload).unwrap();
            console.log("API Response:", result);
            setSalesreturnId(result?.message?.data?.name || "");
            return result?.message?.data?.name || 0;
        } catch (err) {
            console.error("Error saving sales return:", err);
            alert("Failed to save sales return.");
        }
    };
    const handleSavesingle = async () => {
        console.error(' call_save_sales_return', salesreturnfulldata);
        const payload = { doc: salesreturnfulldata };
        try {
            const result = await saveSalesReturn(payload).unwrap();
            console.log("API Response:", result);
            setSalesreturnId(result?.message?.data?.name || "");
            setError('Created');
            setptype('Sales return  Created  uccessfully:');
            setShowError(true);
            // return result?.message?.data?.name || 0;
        } catch (err) {
            console.error("Error saving sales return:", err);
            alert("Failed to save sales return.");
        }
    };
    const [updateSalesReturn, { isLoading: isUpdating }] = useUpdateSalesReturnMutation();


    const handleUpdate = async () => {
        const docPayload = {
            ...deliveryNoteData,
            items: deliveryNoteItems
        };
        console.log("salesreturn_id", salesreturn_id);

        if (salesreturn_id) {
            const updatePayload = {
                doc: {
                    ...docPayload,
                    name: salesreturn_id
                }
            };
            try {
                const result = await updateSalesReturn(updatePayload).unwrap();
                console.log("Update successful:", result);
                setError('Sales return updated');
                setptype('Updated');
                setShowError(true);
            } catch (error) {
                console.error("Update failed:", error);
                alert("Failed to update sales return.");
            }
            console.log("Update payload with ID:", updatePayload);

        } else {
            const newId = await handleSave();
            console.log(newId, "newId_check");


            if (newId) {
                console.log("New sales return created with ID:", newId);
                setSalesreturnId(newId);

                const updatePayload = {
                    doc: {
                        ...docPayload,
                        name: newId
                    }
                };
                try {
                    const result = await updateSalesReturn(updatePayload).unwrap();
                    setError('Sales return Create and updated');
                    setptype('Created');
                    setShowError(true);
                } catch (error) {
                    console.error("Update after creation failed:", error);
                }


            }
        }
    };
    const [submitDeliveryNote, { isLoading: isSubmittingDeliveryNote }] = useSubmitDeliveryNoteMutation();


    const handleSubmitSalesReturn = async () => {
        try {
            const payload = {
                delivery_note_id: salesreturn_id
            };

            const result = await submitDeliveryNote(salesreturn_id).unwrap();
            console.log("Delivery note submitted successfully:", result);
            setError('Sales return submitted');
            setptype('submitted');
            setShowError(true);
            setsubmit(true)
            return result;
        } catch (error) {
            console.error("Failed to submit delivery note:", error);
            alert("Failed to submit delivery note.");
            throw error;
        }
    };




    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe", height: '40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0"> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound-delivery-note')}>Delivery Note List </p>
                    {/* /outbound/outbound-delivery-note */}
                    <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        Sales Return
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >

                            {deliveryNoteData?.status}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px', flexGrow: '1' }} >
                    {!submit && (
                        <>
                            <Button
                                style={{ gap: "2px" }}
                                className="custom-btn-00989"
                                iconName="LuFilePlus2"
                                iconSize={12}
                                onClick={handleUpdate}
                            >
                                Update
                            </Button>

                            {!salesreturn_id && (
                                <Button
                                    style={{ gap: "2px" }}
                                    className="custom-btn-00989"
                                    iconName="LuFilePlus2"
                                    iconSize={12}
                                    onClick={handleSavesingle}
                                >
                                    Save
                                </Button>
                            )}

                            {salesreturn_id && (
                                <Button
                                    style={{ gap: "2px" }}
                                    className="custom-btn-00989"
                                    iconName="LuFilePlus2"
                                    iconSize={12}
                                    onClick={handleSubmitSalesReturn}
                                >
                                    Submit
                                </Button>
                            )}
                        </>
                    )}


                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 2 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(2) }} href="javascript:void(0);">
                                    Address & Contact {tab == 2 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                            <li className="nav-item-tab-custom pb-0 d-flex align-items-end border-radius-top-corner"  >
                                <a className={tab == 3 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(3) }} href="javascript:void(0);">
                                    Shipment {tab == 3 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>

                        </ul>
                        <Attachment doctype="Delivery Note" docname={deliveryNoteId} />
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 salesreturn_id={salesreturn_id} deliveryNoteData={deliveryNoteData} activityboll={activityboll} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex" style={{ gap: '5px' }}>
                            <p className="orangebtn">No. of lines - <span style={{ color: '#2563EB' }}>{deliveryNoteItems?.length}</span></p>
                            <p className="pinkbutton">Total Quantity -  <span style={{ color: '#16A34A' }}>{deliveryNoteData?.total_qty}</span></p>
                            <p className="greenbtn">pick quantity-  <span style={{ color: '#fd8c5c' }}> {deliveryNoteData?.total_qty}</span></p>
                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            setDeliveryNoteItems={setDeliveryNoteItems}
                            deliveryNoteItems={deliveryNoteItems}

                            list_data={deliveryNoteItems}
                            fulldata={deliveryNoteItems}
                            row={{ Rows: deliveryNoteItems, setRows: setDeliveryNoteItems }}

                        />
                    </div>
                    <div className="col-12" style={{ visibility: tab == 2 ? "visible" : 'hidden', height: tab == 2 ? "auto" : '0px' }}> <Tab2 deliveryNoteData={deliveryNoteData} /> </div>
                    <div className="col-12" style={{ visibility: tab == 3 ? "visible" : 'hidden', height: tab == 3 ? "auto" : '0px' }}> <Tab5 deliveryNoteData={deliveryNoteData} deliveryNoteItems={shipmentItems} /> </div>
                    <div className="col-12" style={{ visibility: tab == 4 ? "visible" : 'hidden', height: tab == 4 ? "auto" : '0px' }}> <Tab4 /> </div>
                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={errorr}
                onClose={() => setShowError(false)}
            />

        </>
    )
}

export default SalesReturn
